import React, { Fragment, useRef, useState } from "react";
import { forgotPassword } from "../api/apiClient";
import { useNavigate } from "react-router-dom";

const ForgotPasswordPage = () => {
    const [errors, setErrors] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);
    const emailRef = useRef(null);
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();

        const email = emailRef.current.value;

        if (!email) {
            setErrors({
                email: ["E-Mail ist erforderlich."],
            });
            return;
        }

        setErrors(null);

        forgotPassword(email)
            .then(() => {
                setSuccessMessage(
                    "E-Mail wurde gesendet. Bitte überprüfe deinen Posteingang, um dein Passwort zurückzusetzen."
                );
            })
            .catch(() => {
                setErrors({
                    email: ["Etwas ist schief gelaufen. Bitte versuche es erneut."],
                });
            });
    };

    return (
        <Fragment>
            <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center">
                <div className="w-full max-w-md bg-white shadow-lg rounded-lg p-6">
                    <div className="mb-6">
                        <button
                            className="text-pegasusPurple hover:text-pink-700 font-medium"
                            onClick={() => navigate(-1)}
                        >
                            &lt; Zurück
                        </button>
                    </div>

                    {!successMessage ? (
                        <>
                            <h2 className="text-2xl font-semibold text-gray-800 text-center mb-4">
                                Passwort vergessen?
                            </h2>
                            <p className="text-gray-600 text-center mb-6">
                                Bitte gib die E-Mail-Adresse ein, mit der du dich registriert hast.
                                Wir senden dir dann eine E-Mail, um ein neues Passwort zu erstellen.
                            </p>

                            {errors && (
                                <div className="text-red-500 mb-4">
                                    {Object.keys(errors).map((key) => (
                                        <p key={key}>{errors[key][0]}</p>
                                    ))}
                                </div>
                            )}

                            <form onSubmit={handleSubmit}>
                                <div className="mb-6">
                                    <label
                                        htmlFor="email"
                                        className="block text-sm font-medium text-gray-700"
                                    >
                                        E-Mail*
                                    </label>
                                    <input
                                        type="email"
                                        id="email"
                                        ref={emailRef}
                                        className="w-full border border-gray-300 rounded-md p-2 mt-1 focus:outline-none focus:ring-pegasusPurple focus:border-pegasusPurple"
                                        placeholder="Deine E-Mail"
                                    />
                                </div>
                                <button
                                    type="submit"
                                    className="w-full bg-pegasusPurple text-white py-2 px-4 rounded-md hover:bg-pegasusPurpleHover"
                                >
                                    PASSWORT ZURÜCKSETZEN
                                </button>
                            </form>
                        </>
                    ) : (
                        <div className="text-center">
                            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                                E-Mail gesendet!
                            </h2>
                            <p className="text-gray-600">
                                Bitte überprüfe deinen Posteingang, um dein Passwort zurückzusetzen.
                            </p>
                            <button
                                onClick={() => navigate("/")}
                                className="bg-pegasusPurple text-white py-2 px-6 rounded-lg hover:bg-pegasusPurpleHover"
                            >
                                ZURÜCK ZUM KALENDER
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </Fragment>
    );
};

export default ForgotPasswordPage;
